import { render, staticRenderFns } from "./SwitchInput.vue?vue&type=template&id=236549e0&scoped=true"
import script from "./SwitchInput.vue?vue&type=script&lang=ts"
export * from "./SwitchInput.vue?vue&type=script&lang=ts"
import style0 from "./SwitchInput.vue?vue&type=style&index=0&id=236549e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236549e0",
  null
  
)

export default component.exports